const PENDING_VERSION_KEY = 'tocin-web-pending-version'
const VERSION_CHECK_INTERVAL = 60 * 1000
const VERSION_CHECK_TIMEOUT = 10 * 1000
const MAX_RETRY_INTERVAL = 5 * 60 * 1000

function getAppAsset (value) {
  const match = String(value || '').match(/(?:^|\/)js\/(app\.[a-f0-9]+\.js)(?:\?|$)/i)
  return match ? match[1] : ''
}

function getLoadedAppAsset () {
  return Array.from(document.scripts)
    .map(script => getAppAsset(script.src))
    .find(Boolean) || ''
}

function getLatestAppAsset (html) {
  const match = String(html || '').match(/(?:src=["'])([^"']*\/js\/app\.[a-f0-9]+\.js(?:\?[^"']*)?)["']/i)
  return match ? getAppAsset(match[1]) : ''
}

function isPaymentFlowRoute (path) {
  return /^\/member\/shopcart\/step\/[2-5](?:\/|$)/.test(path || '')
}

export function initAppVersionUpdater (router) {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  let checking = false
  let nextCheckAt = 0
  let failures = 0

  const reloadForUpdate = () => {
    sessionStorage.removeItem(PENDING_VERSION_KEY)
    window.location.reload()
  }

  const checkVersion = async () => {
    if (checking || document.visibilityState === 'hidden' || window.navigator.onLine === false) {
      return
    }

    const loadedAsset = getLoadedAppAsset()
    if (!loadedAsset) {
      return
    }

    const currentPath = router.currentRoute && router.currentRoute.path
    const pendingAsset = sessionStorage.getItem(PENDING_VERSION_KEY)
    if (pendingAsset === loadedAsset) {
      sessionStorage.removeItem(PENDING_VERSION_KEY)
    } else if (pendingAsset && !isPaymentFlowRoute(currentPath)) {
      reloadForUpdate()
      return
    }

    if (Date.now() < nextCheckAt) {
      return
    }

    checking = true
    const controller = new window.AbortController()
    const timeout = window.setTimeout(() => controller.abort(), VERSION_CHECK_TIMEOUT)
    try {
      const response = await window.fetch(`/index.html?app_version=${Date.now()}`, {
        signal: controller.signal,
        cache: 'no-store',
        credentials: 'same-origin',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      if (!response.ok) {
        throw new Error('Version check failed')
      }

      const latestAsset = getLatestAppAsset(await response.text())
      failures = 0
      nextCheckAt = Date.now() + VERSION_CHECK_INTERVAL
      if (!latestAsset || latestAsset === loadedAsset) {
        return
      }

      sessionStorage.setItem(PENDING_VERSION_KEY, latestAsset)
      if (!isPaymentFlowRoute(currentPath)) {
        reloadForUpdate()
      }
    } catch (error) {
      // 連線失敗逐步延長重試間隔，避免切頁時密集重送。
      failures += 1
      nextCheckAt = Date.now() + Math.min(VERSION_CHECK_INTERVAL * Math.pow(2, failures - 1), MAX_RETRY_INTERVAL)
    } finally {
      window.clearTimeout(timeout)
      checking = false
    }
  }

  router.afterEach(() => {
    window.setTimeout(checkVersion, 0)
  })

  window.addEventListener('online', checkVersion)

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkVersion()
    }
  })

  window.setInterval(checkVersion, VERSION_CHECK_INTERVAL)
  checkVersion()
}
